/** Shared centered-card layout for lighter content pages (legal, press, newsletter, 404). */
export default function SimplePage({ title, children, maxWidth = "760px" }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div className="tl-container" style={{ padding: "64px 40px 96px", maxWidth }}>
        <div className="tl-card-light" style={{ display: "flex", flexDirection: "column", gap: "16px", padding: "44px 40px" }}>
          <h1 style={{ fontFamily: "var(--font-serif)", fontSize: "34px", lineHeight: 1.15, color: "var(--color-ink)", margin: 0 }}>
            {title}
          </h1>
          {children}
        </div>
      </div>
    </div>
  );
}
